import React, { FC } from 'react';

import List from '@material-ui/core/List';

import ChatItem from './item';

import { Typography } from '@material-ui/core';

export interface IProductMessage {
  isAdmin?: boolean;
  isProducer?: boolean;
  name?: string;
  text?: string;
  created_at: string;
  updated_at?: string;
  deleted?: boolean;
}

interface MessagesProps {
  loading?: boolean;
  isError?: boolean;
  messages: IProductMessage[];
}

const Messages: FC<MessagesProps> = ({ loading, isError, messages }) => {
  return (
    <div>
      {loading && messages.length === 0 && <Typography>Laddar kommentarer…</Typography>}
      {isError && <Typography color="error">Kunde inte ladda kommentarer.</Typography>}
      {!loading && !isError && messages.length === 0 && (
        <Typography color="textSecondary">Inga kommentarer ännu.</Typography>
      )}
      <List>
        {messages.map((message, index) => (
          <ChatItem key={message.created_at || index} message={message} />
        ))}
      </List>
    </div>
  );
};

export default Messages;
